// import Overview from "../components/views/Overview";
import TractorBooking from "../components/views/TractorBooking";
import AggregateBooking from "../components/views/AggregateBooking";
import FiveMBooking from "../components/views/FiveMBooking";
import TransporterData from "../components/views/TransporterData";
import ContainerDiversion from "../components/views/ContainerDiversion";
import ArrivalReport from "../components/views/ArrivalReport";
import ContainerMasterData from "../components/views/ContainerMasterData";
import DepartureReport from "../components/views/DepartureReport";
import VGMData from "../components/views/VGMData";
import TractorEtaData from "../components/views/TractorEtaData";
import AggregateEtaData from "../components/views/AggregateEtaData";
// import DailyPlanEmailWindow from "../email-template/dailyPlanEmailWindow";
// import InvoicePackingEmailWindow from "../email-template/invoicePackingEmailWindow";
// import VGMEmailWindow from "../email-template/VGMEmailWindow";
import ContainerReport from "../components/views/ContainerReport";
import MainEmailWindow from "../email-template/MainEmailWindow";
import NewDashboard from "../pages/new-dashboard/new-dashboard";
import Supplier from "../components/views/Supplier-s2";
import UploadedFiles from "../components/views/UploadedFiles";
import ReportsList from "../components/views/Factory";
import Factory from "../components/views/Factory";
import Shared from "../components/views/Shared";
import SevenYReports from "../components/views/SevenYReports";

import SupplierReport from "../components/views/Supplier";

export const routeMapping = [
	{
		SubMenuName: "Dashboard",
		pathName: "/dashboard/overview",
		component: NewDashboard,
	},
	{
		SubMenuName: "Tractor",
		pathName: "/dashboard/booking/tractor",
		component: TractorBooking,
	},
	{
		SubMenuName: "Aggregate",
		pathName: "/dashboard/booking/aggregate",
		component: AggregateBooking,
	},
	{
		SubMenuName: "5M",
		pathName: "/dashboard/booking/fiveM",
		component: FiveMBooking,
	},
	{
		SubMenuName: "Transporter",
		pathName: "/dashboard/transporter",
		component: TransporterData,
	},
	{
		SubMenuName: "Container Diversion",
		pathName: "/dashboard/Container-Diversion",
		component: ContainerDiversion,
	},
	{
		SubMenuName: "Arrival Report",
		pathName: "/dashboard/arrival-report",
		component: ArrivalReport,
	},
	{
		SubMenuName: "Container Master",
		pathName: "/dashboard/container-master",
		component: ContainerMasterData,
	},
	{
		SubMenuName: "Departure Report",
		pathName: "/dashboard/departure-report",
		component: DepartureReport,
	},
	{
		SubMenuName: "VGM",
		pathName: "/dashboard/VGM",
		component: VGMData,
	},
	{
		SubMenuName: "Share Email",
		pathName: "/dashboard/share-email",
		component: MainEmailWindow,
	},
	// {
	//   SubMenuName: 'Invoice Packing Email',
	//   pathName: "/dashboard/invoice-packing-email",
	//   component: InvoicePackingEmailWindow,
	// },
	// {
	//   SubMenuName: 'VGM Email',
	//   pathName: "/dashboard/VGM-email",
	//   component: VGMEmailWindow,
	// },
	{
		SubMenuName: "Container Report",
		pathName: "/dashboard/container-report",
		component: ContainerReport,
	},
	{
		SubMenuName: "Tractor ETA",
		pathName: "/dashboard/tractor-ETA",
		component: TractorEtaData,
	},
	{
		SubMenuName: "Aggregate ETA",
		pathName: "/dashboard/aggregate-ETA",
		component: AggregateEtaData,
	},
	{
		SubMenuName: "Supplier S2",
		pathName: "/dashboard/Supplier-S2",
		component: Supplier,
	},
	{
		SubMenuName: "Uploaded File List",
		pathName: "/dashboard/UploadedFiles",
		component: UploadedFiles,
	},
	
	{
  SubMenuName: "Factory",
  pathName: "/dashboard/Factory",
  component: Factory,
},	{
  SubMenuName: "Shared",
  pathName: "/dashboard/Shared",
  component: Shared,
},
	{
  SubMenuName: "Supplier",
  pathName: "/dashboard/Supplier",
  component: SupplierReport,
},

	{
  SubMenuName: "7Y Reports",
  pathName: "/dashboard/hound",
  component: SevenYReports,
},

];
